import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

type NoDataAvailableArgs = {
  editDataset: OnButtonClick;
  showActionControls?: boolean;
  i18nLocale: I18nLocale;
};

export const noDataAvailable = ({
  editDataset,
  showActionControls = true,
  i18nLocale,
}: NoDataAvailableArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noDataAvailable.title',
    'There is no data to show'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noDataAvailable.description',
    'Try editing your dataset, check the filters and any other selections'
  ),
  children: !showActionControls ? null : (
    <PrimaryButton onClick={editDataset}>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noDataAvailable.editDataset',
        'Edit dataset'
      )}
    </PrimaryButton>
  ),
});
